<template>
	<el-tabs type="border-card" v-model="tabs" @tab-remove="Tabremove">
		<el-tab-pane label="海报管理" name="lie">
			<el-form ref="form" :model="so" label-width="100px">
				<el-form-item label="海报名称">
					<el-input v-model="so.guanjianci"></el-input>
				</el-form-item>
				<el-form-item abel-width="240px">
					<el-button type="info" size="small" @click="CSH">搜索</el-button>
				</el-form-item>
			</el-form>
			<el-divider></el-divider>
			<el-table :data="lie" style="width: 100%; margin-bottom: 30px;" stripe>
				<el-table-column prop="id" label="ID" width="100">
				</el-table-column>
				<el-table-column prop="ming" label="海报名称" width="200">

				</el-table-column>
				<el-table-column label="海报类型" width="180">
					<template slot-scope="shu">						
						<el-tag type="danger" effect="dark" size="small" v-if="shu.row.leixing==1">拼团</el-tag>
						<el-tag type="danger" effect="dark" size="small" v-else-if="shu.row.leixing==2">兑换</el-tag>
						<el-tag type="danger" effect="dark" size="small" v-else-if="shu.row.leixing==3">砍价</el-tag>
						<el-tag type="danger" effect="dark" size="small" v-else-if="shu.row.leixing==4">商品详情</el-tag>
						<el-tag type="danger" effect="dark" size="small" v-else>系统</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="guanjianci" label="关键词" width="180">
				</el-table-column>
				<el-table-column label="是否默认" width="180">
					<template slot-scope="shu">
						<el-switch v-model="shu.row.moren" @change="Moren(shu.row)" active-value="1" inactive-value="0"></el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="操作">
					<template slot-scope="shu">
						<el-button type="success"  @click="Bianji(shu.row)">编辑</el-button>
						<el-button @click="Shanchu(shu.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;"/>
		</el-tab-pane>
		<el-tab-pane :label="mianban_shu.id?'编辑海报':'新增海报'" name="xinzeng" :closable="mianban_shu.id>0">
			<el-form ref="form" :model="mianban_shu" label-width="100px">
				<el-form-item label="海报名称">
					<el-input v-model="mianban_shu.ming"></el-input>
				</el-form-item>
				<el-form-item label="海报类型">
					<el-radio-group v-model="mianban_shu.leixing">
						<el-radio label="0">系统</el-radio>
						<el-radio label="1">拼团</el-radio>
						<el-radio label="2">兑换</el-radio>
						<el-radio label="3">砍价</el-radio>
						<el-radio label="4">商品详情</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="生成二维码关键词">
					<el-input v-model="mianban_shu.guanjianci"></el-input>
					<div style="color:#a3a3a3 ;">如果是商品海报 ，回复关键词是 关键词+商品ID</div>
				</el-form-item>
				<el-form-item label="是否默认">
					<el-radio-group v-model="mianban_shu.moren">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
					<div style="color:#a3a3a3 ;">是否是海报类型的默认设置，一种海报只能一个默认设置</div>
				</el-form-item>
				<!-- <template slot-scope="scope"> -->
				<el-form-item label="海报设计">
					<div>
			
						<table style="100%">
							<tr>
								<td>
									<div class="shangtus" :style="beijing">
											<Tuodongdaxiao v-for="(l,i) in mianban_shu.shu" :shu.sync="l" :i="i" @Youji="Youji" @Zuoji="Zuoji" v-if="l"></Tuodongdaxiao>
											<div class="Youjicaidan" :style="youjiyangshi">
												<div @click="Cengci(1)">上一层</div>
												<div @click="Cengci(2)">下一层</div>
												<div @click="Cengci(3)">删除</div>
												<div @click="Cengci(0)">取消</div>
											</div>
											</div>
								</td>
								<td style="padding:0 !important;position: relative;">
									<div class="shangtu_right" >
										<el-form>
											<el-form-item label="背景图片" label-width="100px">
												<Shangwenjian v-model="mianban_shu.beijing" anniu="选择图片" leixing="tu"></Shangwenjian>
													<div class="tishi">背景图片大小为 375px * 667px</div>
											</el-form-item>
											<el-form-item label="海报元素" label-width="100px" class="annius p_adding">
												<el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'touxiang',z: 1})">头像</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'nicheng',z: 1})">昵称</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'erweima',z: 1})">二维码</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'tuijianma',z: 1})">推荐码</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shangpinming',z: 1})">商品名称</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'shangpintu',z: 1})">商品图片</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shangpinjiage',z: 1})">商品现价</el-button>
												<el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shangpinyuanjia',z: 1})">商品原价</el-button>
											</el-form-item>
											<!-- <el-form-item label="图片设置" label-width="100px" class="annius">
												<Shangwenjian v-model="n1" anniu="选择图片" leixing="tu"></Shangwenjian>
											</el-form-item>
											<el-form-item label="昵称颜色" label-width="100px" class="annius" v-show="niCheng2">
												<el-input></el-input>
											</el-form-item>
											<el-form-item label="昵称大小" label-width="100px" class="annius" v-show="niCheng3">
												<el-input></el-input>
											</el-form-item> -->
											
											<el-form-item label="昵称大小"  label-width="100px" class="annius p_adding" v-show="niCheng2">
												<el-input v-model="mianban_shu.nicheng"></el-input>
											
											</el-form-item>
											<el-form-item label="昵称颜色" label-width="100px" class="annius p_adding" v-show="niCheng2">
												<el-input></el-input>
											</el-form-item>
											
											<el-form-item label="推荐码大小" label-width="100px" class="annius p_adding" v-show="tuijianma2">
												<el-input ></el-input>
											</el-form-item>
											<el-form-item label="推荐码颜色" label-width="100px" class="annius p_adding" v-show="tuijianma2">
												<el-input></el-input>
											</el-form-item>
											
											<el-form-item label="商品名称大小" label-width="100px" class="annius p_adding" v-show="shangpinming2">
												<el-input ></el-input>
											</el-form-item>
											<el-form-item label="商品名称颜色" label-width="100px" class="annius p_adding" v-show="shangpinming2">
												<el-input></el-input>
											</el-form-item>
											
											<el-form-item label="商品现价大小" label-width="100px" class="annius p_adding" v-show="shangpinjiage2">
												<el-input ></el-input>
											</el-form-item>
											<el-form-item label="商品现价颜色" label-width="100px" class="annius p_adding" v-show="shangpinjiage2">
												<el-input></el-input>
											</el-form-item>
											
											<el-form-item label="商品原价大小" label-width="100px" class="annius p_adding" v-show="shangpinyuanjia2">
												<el-input ></el-input>
											</el-form-item>
											<el-form-item label="商品原价颜色" label-width="100px" class="annius p_adding" v-show="shangpinyuanjia2">
												<el-input></el-input>
											</el-form-item>
										</el-form>
									</div>
								</td>
								</tr>
							
						</table>
						
					</div>
				</el-form-item>

				<el-form-item label="生成等待文字">
					<el-input type="textarea" autosize placeholder="您的专属海报正在拼命生成中，请等待片刻···" v-model="mianban_shu.dengdaitishi" :rows="8">
					</el-input>
				</el-form-item>
				<el-form-item label="">
					<Tijiao @click="Tijiao"></Tijiao>
				</el-form-item>
			</el-form>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	import Shangtu from '../../zujian/Shangtu.vue'
	import Tuodongdaxiao from '../../zujian/Tuodongdaxiao.vue'
	var that;
	export default {
		data() {
			return {
				mianban_shu: {shu:[]},
				youjiyangshi: '',
				tuodongdaxiao: {},
				beijing: '',
				so: {
					ye: 1,
					jitiao: 20
				},
				zongshu: 0,
				lie: [],
				tabs:'lie',	
				niCheng2:false,
				tuijianma2:false,
				shangpinming2:false,
				shangpinjiage2:false,
				shangpinyuanjia2:false,
			}
		},
		created() {
			that = this;
			that.CSH();
		},
		components: {
			Shangtu,
			Shangwenjian,
			Tuodongdaxiao
		},
		watch: {
			"mianban_shu.beijing": function() {
				this.beijing = "background: url(" + this.mianban_shu.beijing +");background-size: auto;background-repeat: no-repeat;"
			}
		},
		methods: {
			CSH() {
				this.$post('k=haibao', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Youji(a, b) {
				this.tuodongdaxiao = b;
				this.youjiyangshi = "left:" + (a.layerX + b.x) + "px;top:" + (a.layerY + b.y) + 'px;display:block';
			},
			Cengci(e) {
				if (e == 1) {
					this.tuodongdaxiao.z += 1;
				} else if (e == 2 && this.tuodongdaxiao.z > 0) {
					this.tuodongdaxiao.z -= 1;
				} else if (e == 3) {
					this.mianban_shu.shu[this.tuodongdaxiao.i] = false;
				}
				this.youjiyangshi = 'display:none';
			},

			Zuoji(e) {
				this.tuodongdaxiao = e;
				console.log(this.tuodongdaxiao)
				if(e.leixing=="nicheng"){this.niCheng2=true }else{this.niCheng2=false;}
				if(e.leixing=="tuijianma"){this.tuijianma2=true }else{this.tuijianma2=false;}
				if(e.leixing=="shangpinming"){this.shangpinming2=true }else{this.shangpinming2=false;}
				if(e.leixing=="shangpinjiage"){this.shangpinjiage2=true }else{this.shangpinjiage2=false;}
				if(e.leixing=="shangpinyuanjia"){this.shangpinyuanjia2=true }else{this.shangpinyuanjia2=false;}
			},
			Tianjia(e) {
				e.x=0;
				e.y=0;
				

				
				this.mianban_shu.shu.push(e)
			},
			Tijiao() {
				this.$post("k=haibao&c=xiugai", this.mianban_shu, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}
				})
			},
			Moren(e){
				this.$post("k=haibao&c=xiugai", e, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}
				})
			},
			Shanchu(e){
				this.$post("k=haibao&c=shandiao",{id:e.id}, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}
				})
			},
			Tabremove(e){
				that.tabs='lie';
				that.mianban_shu={shu:[]};				
			},
			Bianji(e){
				// that.mianban_shu=[];
				that.tabs='xinzeng';
				that.mianban_shu=e;
				if(!that.mianban_shu.shu){
					that.$set(that.mianban_shu,'shu',[])
				}
			},

		}
	}
</script>

<style>
	body{
		min-width: 1295px;
	}
	.p_adding{margin-top: 20px;}
	.tishi {
		color: #737373;
	}

	.shangtuqu {
		display: flex;
	}

	.shangtus {
		width: 375px;
		height: 667px;
		border: 1px solid #cccccc;
		box-sizing: content-box;
		margin-right: 40px;
		position: relative;
	}

	.shangtu_right {
		border: 1px solid #cccccc;
		/* padding: 20px; */
		/* width: 600px; */
		padding: 40px;
		margin-top: -330px;
	}
</style>
